import { render, staticRenderFns } from "./StartupsCategoryChart.vue?vue&type=template&id=c1726b0c&"
import script from "./StartupsCategoryChart.vue?vue&type=script&lang=js&"
export * from "./StartupsCategoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports